import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import styles from './Switcher.module.scss';
export const Switcher = ({ active, onChange, items }) => {
    const onClick = (id) => {
        if (id !== active) {
            onChange(id);
        }
    };
    return (_jsx("div", Object.assign({ className: styles.switch }, { children: items.map((item) => (_jsx("div", Object.assign({ className: classNames(styles.item, active === item.id && styles.itemActive), onClick: () => void onClick(item.id) }, { children: item.title }), item.id))) })));
};
